import 'js/rotate';
import 'js/becomeMemberExt';
import './widgetsBase.scss';

function lazyLoad(importFn, exportName = 'default') {
  return function (...args) {
    return importFn().then((module) => {
      const fn = exportName === 'default' ? module.default : module[exportName];
      return fn(...args);
    });
  };
}

window.renderSlider = lazyLoad(() => import('js/slider.jsx'), 'renderSlider');
window.renderSliderImageVideo = lazyLoad(() => import('js/sliderImageVideo'), 'renderSliderImageVideo');
window.renderCarousel = lazyLoad(() => import('js/carousel'), 'renderCarousel');
window.renderHotelSlider = lazyLoad(() => import('js/slickSlider'), 'renderHotelSlider');
window.renderTab = lazyLoad(() => import('js/tabSlider'), 'renderTab');
window.renderTabs = lazyLoad(() => import('js/tabs'), 'renderTabs');
window.renderAccordions = lazyLoad(() => import('js/accordions'), 'renderAccordions');
window.renderPriceDecrease = lazyLoad(() => import('js/priceDecrease'), 'renderPriceDecrease');
window.renderSliderQuotes = lazyLoad(() => import('js/quotesSlider'), 'renderSliderQuotes');
window.renderDestinationFilter = lazyLoad(() => import('js/destinationFilter'), 'renderDestinationFilter');
window.rendertabsImages = lazyLoad(() => import('js/tabsImages'), 'rendertabsImages');
window.renderPersonalData = lazyLoad(() => import('js/personalData'), 'renderPersonalData');
window.renderDestinationsPushSlider = lazyLoad(() => import('js/destinationsPushSlider'), 'renderDestinationsPushSlider');
window.renderSimplePopup = lazyLoad(() => import('js/simplePopup'), 'renderSimplePopup');
window.renderBenefitsWidget = lazyLoad(() => import('js/components/benefits/benefits'));
window.renderSliderCols = lazyLoad(() => import('js/slider3col'));
window.renderSliderOneCol = lazyLoad(() => import('js/slider1col'));
window.renderHotelIntroSliderReact = lazyLoad(() => import('js/components/hotelIntroSlider/HotelIntroSlider'));
window.renderTabFaq = lazyLoad(() => import('js/tabFaq'));
window.renderDestinationMap = lazyLoad(() => import('js/destination-map'));
window.renderCheckSlider = lazyLoad(() => import('js/checkSlider'));
window.renderSliderMultiPicture = lazyLoad(() => import('js/multiPictureSlider'));
window.hotelPushesUpdate = lazyLoad(() => import('js/hotelPushesUpdate'));
window.renderHomeIntroSlider = lazyLoad(() => import('js/homeIntroSlider'));
